module.exports = __webpack_public_path__ + "static/media/yes_video.16ae5756.svg";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/yes_video.svg
// module id = ./src/statics/images/yes_video.svg
// module chunks = 0